import { TextField, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { CareerSiteSettings } from 'api-clients/monolith';
import React, { VFC } from 'react';

import { SettingTitle } from './Components/SettingTitle';

import { Description } from './Components/Description';
import { SectionTitle } from './Components/SectionTitle';
import { SettingSwitch } from './Components/SettingSwitch';
import { messages } from './messages';
import { HandleSettingChange } from './types';

const useStyles = makeStyles(theme => ({
  title: {
    marginTop: theme.spacing(2),
  },
  switch: {
    marginTop: theme.spacing(4),
  },
  primaryTitle: {
    marginTop: theme.spacing(4),
  },
}));

export interface SsoSettingsProps {
  settings: CareerSiteSettings;
  handleSettingChange: HandleSettingChange;
}

export const SsoSettings: VFC<SsoSettingsProps> = ({
  settings,
  handleSettingChange,
}) => {
  const styles = useStyles();

  return (
    <section>
      <SectionTitle value={messages.ssoSettings} />
      <SettingSwitch
        settingKey="sso_enabled"
        label={messages.ssoEnabled}
        checked={settings.sso_enabled}
        onChange={handleSettingChange}
      />
      <Description value={messages.ssoSettingDescription} />

      <SettingTitle
        value={messages.serviceProviderTitle}
        className={styles.primaryTitle}
      />

      <SettingTitle value={messages.acsUrl} className={styles.title} />

      <Typography variant="body2" className={styles.title}>
        {settings.sp_acs_url}
      </Typography>

      <SettingTitle value={messages.spEntityId} className={styles.title} />

      <Typography variant="body2" className={styles.title}>
        {settings.sp_entity_id}
      </Typography>

      <SettingTitle value={messages.spMetaData} className={styles.title} />
      {settings.sp_metadata && (
        <Typography variant="body2" className={styles.title}>
          <a
            href={settings.sp_metadata}
            target="_blank"
            rel="noopener noreferrer"
          >
            {settings.sp_metadata}
          </a>
        </Typography>
      )}

      <SettingTitle
        value={messages.identityProviderTitle}
        className={styles.primaryTitle}
      />

      <SettingTitle value={messages.loginUrl} className={styles.title} />

      <TextField
        id="idp_login_url"
        style={{ margin: '8px 0' }}
        fullWidth
        value={settings?.idp_login_url ?? ''}
        onChange={e => handleSettingChange('idp_login_url', e.target.value)}
        margin="normal"
        InputLabelProps={{
          shrink: true,
        }}
        variant="outlined"
        disabled={!settings?.sso_enabled}
        required={settings?.sso_enabled}
      />

      <SettingTitle value={messages.idpEntityId} className={styles.title} />

      <TextField
        id="idp_entity_id"
        style={{ margin: '8px 0' }}
        fullWidth
        value={settings?.idp_entity_id ?? ''}
        onChange={e => handleSettingChange('idp_entity_id', e.target.value)}
        margin="normal"
        InputLabelProps={{
          shrink: true,
        }}
        variant="outlined"
        disabled={!settings?.sso_enabled}
        required={settings?.sso_enabled}
      />

      <SettingTitle value={messages.idpCertificate} className={styles.title} />

      <TextField
        id="idp_certificate"
        style={{ margin: '8px 0' }}
        fullWidth
        value={settings?.idp_certificate ?? ''}
        onChange={e => handleSettingChange('idp_certificate', e.target.value)}
        margin="normal"
        InputLabelProps={{
          shrink: true,
        }}
        variant="outlined"
        disabled={!settings?.sso_enabled}
        multiline
        rows={8}
        rowsMax={10}
        required={settings?.sso_enabled}
      />
    </section>
  );
};
